// @ts-nocheck
export default class RetryablePasswordResetError extends Error {}
